// material-ui
import { useTheme } from '@mui/material/styles';
import { Grid, Backdrop, CircularProgress, Tooltip, Alert, Typography, IconButton, List, ListItem} from '@mui/material';
import React, { useState, useEffect, useRef } from 'react';
// project imports
import SubCard from 'src/components/cards/SubCard';
import html2canvas from 'html2canvas';
import beratSvg from 'src/assets/images/img/Berat.png';
import { makeStyles } from '@material-ui/styles';
import axios from 'src/utils/axios';
import ArcelikImg from 'src/assets/images/img/1.png';
import BekoImg from 'src/assets/images/img/2.png';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { getUser } from 'src/utils/Common';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import { Card } from '@material-ui/core';
// ==============================|| PROFILE 1 - CHANGE PASSWORD ||============================== //
const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const Certificate = ({ EmployeeNr, OrganizationTypeId }) => {
  const theme = useTheme();
  const SessionUser = getUser();
  if (EmployeeNr === 0) {
    return <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12}>
        <Alert variant="outlined" severity="error" sx={{ borderColor: theme.palette.warning.dark }}>
          <Typography variant='h5' style={{ color: 'red' }}>Önce Kayıt İşlemini Tamamlamanız Gerekli!....
          </Typography>
        </Alert>      </Grid>
    </Grid>
  };
  const svgRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [txtHeader, settxtHeader] = useState('Değerli Yetkili Servis');
  const [NameSurname, setNameSurname] = useState('');
  const [beratAvailable, setBeratAvailable] = useState(false);
  const [beratHistory, setBeratHistory] = useState([]);
  const classes = useStyles();
  const textStyle1 = {
    fontSize: '70px',
    fontFamily: 'Poppins-Regular_2h',
    fill: '#B27409', // Use 'fill' instead of 'color' for SVG text elements
  };

  const textStyle2 = {
    fontSize: '27px',
    fontFamily: 'Poppins-Regular_2h',
    fill: 'rgba(0, 0, 0, 0.8)',
  };

  const textStyle3 = {
    fontSize: '31px',
    fontFamily: 'Poppins-Regular_2h',
    fill: 'rgba(178, 116, 9, 0.8)',
  };

  const containerStyle = {
    overflow: 'hidden',
    position: 'relative',
    backgroundColor: 'white',
    width: '1286px',
    height: '909px',
  };

  useEffect(() => {
    setLoading(true);
    axios.get(`GetWorkerInfo/${EmployeeNr}`).then((response) => {
      setNameSurname(response.data[0]?.Name + ' ' + response.data[0]?.Surname);
      if (response.data[0]?.BeratAvailable === true) {
        setBeratAvailable(true);
      }
      setLoading(false);
    });
    if (OrganizationTypeId === 2) {
      settxtHeader('Değerli Yetkili Bayi');
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    axios.get(`GetEmployeeBeratHistory/${EmployeeNr}`).then((response) => {
      if (response.data.length > 0) {
        setBeratHistory(response.data);
      }
      setLoading(false);
    });
  }, []);


  const textLength = NameSurname.length;
  const svgWidth = 1000;
  const textStyle1X = (svgWidth - (textLength * 9)) / 2;

  const handleDownloadImage = () => {
    const svgElement = svgRef.current;

    // SVG içerisindeki image etiketlerini resimlere dönüştürme
    const images = svgElement.getElementsByTagName('image');
    const imagePromises = [];

    for (let i = 0; i < images.length; i++) {
      const image = images[i];
      const imageUrl = image.getAttribute('href');
      const promise = new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = 'Anonymous';
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          image.setAttribute('href', canvas.toDataURL());
          resolve();
        };
        img.src = imageUrl;
      });
      imagePromises.push(promise);
    }

    // Tüm resimler işlendikten sonra SVG içeriğini resim olarak indirme
    Promise.all(imagePromises).then(() => {
      html2canvas(svgElement, { background: '#FFFFFF' }).then((canvas) => {
        const link = document.createElement('a');
        link.download = NameSurname + '.png';
        link.href = canvas.toDataURL();
        link.click();
      });
    });
  };



  return (
    <div>
      {
        loading ?
          <Backdrop className={classes.backdrop} open={loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          : <div></div>
      }
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={12}>
          <SubCard title={
            <Grid container justify="center" alignItems="center" >
              <Grid item xs={4} sm={4} md={4} >
                Berat İşlemleri
              </Grid>
              <Grid item xs={4} sm={4} md={4} >
                <Grid container justifyContent="center" alignItems="center">
                  <Grid item >

                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={4} sm={4} md={4} >
                <Grid container justifyContent="right" alignItems="center">
                  {beratAvailable &&
                    < Grid item >
                      <Tooltip title="İndir">
                        <IconButton size="large" color="primary" onClick={handleDownloadImage}>
                          <CloudDownloadIcon />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  }
                </Grid>
              </Grid>
            </Grid>
          }

            style={{ minHeight: 400, maxHeight: 400, overflowY: 'auto' }}>
            {beratHistory.length > 0 && (
              <Grid item xs={12} sm={12} md={12}>
                <Card>
                  <List>
                    {beratHistory.map((row) => (
                      <ListItem key={row.BeratYil}>
                        <WorkspacePremiumIcon
                          color="primary"
                        />
                        &nbsp;
                        <b>{row.BeratYil} Yıl Beratı </b>
                        &nbsp;
                        {` (Verildiği Yıl: ${row.BeratHakEdisYil})`}
                      </ListItem>
                    ))}
                  </List>
                </Card>
              </Grid>
            )}
            {beratAvailable && beratHistory.length > 0 &&
              <Grid item xs={12} sm={12} md={12} paddingTop={2}>
                <div style={{ margin: 0 }}>
                  <div id="p1" ref={svgRef} style={containerStyle}>
                    <svg width="1286" height="909" xmlns="http://www.w3.org/2000/svg">
                      {/* Render the SVG image */}
                      <image href={beratSvg} width="1286" height="909" />
                      {/* Render the text elements */}
                      <text x="350" y="230" style={textStyle1}>
                        {txtHeader}
                      </text>
                      <text x="520" y="300" style={textStyle1}>
                        Çalışanı,
                      </text>
                      <text x={textStyle1X} y="370" style={textStyle1}>
                        {NameSurname}
                      </text>
                      <text x="310" y="480" style={textStyle2}>
                        Meslek hayatınızda uzun yıllar boyunca gösterdiğiniz özveri ve
                      </text>
                      <text x="300" y="510" style={textStyle2}>
                        müşteri memnuniyetine yönelik başarılı çalışmalarınızdan dolayı
                      </text>
                      <text x="400" y="540" style={textStyle2}>
                        teşekkür eder, başarılarınızın devamını dileriz.
                      </text>
                      <text x="500" y="660" style={textStyle3}>
                        Arçelik Pazarlama A.Ş.
                      </text>
                      <text x="440" y="690" style={textStyle3}>
                        Müşteri Hizmetleri Direktörlüğü
                      </text>
                      <image href={ArcelikImg} x="420" y="740" />
                      <image href={BekoImg} x="760" y="740" />
                    </svg>
                  </div>
                </div>
              </Grid>
            }
          </SubCard>
        </Grid>
      </Grid >
    </div >
  );
};

export default Certificate;
